export default {
	name: 'Offchain Lend',
	slug: 'offchainLend',
	description: 'Record lends that occurred off the blockchain',
	version: '1.0.0',
	icon: null,
	countersign: 'Optional',
	fields: [
		{
			name: 'Start Date',
			slug: 'startDate',
			required: true,
			type: 'date',
			placeholder: 'Select a Date',
		},
		{
			name: 'End Date',
			slug: 'endDate',
			required: true,
			type: 'date',
			placeholder: 'Select a Date',
		},
		{
			name: 'Owner Address',
			slug: 'ownerAddress',
			required: true,
			type: 'text',
			placeholder: 'The Address of the Owner',
		},
		{
			name: 'Receiver Address',
			slug: 'receiverAddress',
			required: true,
			type: 'text',
			placeholder: 'The Address of the Receiver',
		},
		{
			name: 'Countersign Status',
			slug: 'countersignStatus',
			required: false,
			type: 'text',
			hidden: true,
			placeholder: 'The status of the Countersign',
		},
		{
			name: 'Countersign Required',
			slug: 'countersignRequired',
			required: false,
			type: 'boolean',
			hidden: true,
			placeholder: 'Does this require a countersign?',
		},
		{
			name: 'Amount',
			slug: 'amount',
			required: false,
			type: 'number',
			fieldMin: 0,
			fieldStep: 0.000000000000000001,
			placeholder: 'An amount associated with this event',
		},
		{
			name: 'Currency',
			slug: 'currency',
			required: false,
			type: 'text',
			placeholder: 'The currency for the above amount',
		},
		{
			name: 'Description',
			slug: 'description',
			required: false,
			type: 'text',
			placeholder: 'A description of the offchain lend',
		},
	],
	info: '',
}
